import { IResponseItem } from '@r1-frontend/api-domru/content-static/v2/news/dto/responseDto';

import { INewsFormatted } from '~/src/entities/formattedNews';
import { IAction } from '~/src/store';
import { ERROR_NEWS, GET_NEWS, SET_NEWS } from '~/src/store/actionTypes/news';

interface IFetchNews {
    fetching: boolean,
}
export function setNewsFetching(state: IFetchNews): IAction<typeof GET_NEWS, IFetchNews> {
    return {
        type: GET_NEWS,
        payload: state,
    };
}

interface ISetNews extends IFetchNews, INewsFormatted {
    itemsByAlias: IResponseItem[],
}

export function setNews(state: ISetNews): IAction<typeof SET_NEWS, ISetNews> {
    return {
        type: SET_NEWS,
        payload: state,
    };
}

interface IErrorTags extends IFetchNews {
    fetchError: string,
}

export function setErrorNews(state: IErrorTags): IAction<typeof ERROR_NEWS, IErrorTags> {
    return {
        type: ERROR_NEWS,
        payload: state,
    };
}
